export const APP_ENV = (() => {
  // Normalize VITE_APP_ENV to one of: production | staging | development.
  const rawEnv = import.meta.env.VITE_APP_ENV;
  if (rawEnv === 'production') return 'production';
  if (rawEnv === 'staging') return 'staging';
  return 'development';
})();

export const isProduction = APP_ENV === 'production';
export const isStaging = APP_ENV === 'staging';
export const isDev = APP_ENV === 'development';

const { VITE_UNSPLASH_ACCESS_KEY, VITE_GOOGLE_MAP_KEY } = import.meta.env;

if (!VITE_UNSPLASH_ACCESS_KEY || typeof VITE_GOOGLE_MAP_KEY !== 'string')
  throw new Error('필요한 환경 변수가 할당되지 않았습니다');

export const unsplashAccessKey = VITE_UNSPLASH_ACCESS_KEY;
export const googleMapKey = VITE_GOOGLE_MAP_KEY;

export const VITE_SENTRY_RELEASE = import.meta.env.VITE_SENTRY_RELEASE as string | undefined;

// Station uses the test host for non-production environments, including staging.
export const STATION_URL = isProduction ? 'station.realworld.to' : 'station-test.realworld.to';

// Toss Payments uses the test key for non-production environments, including staging.
export const TOSSPAYMENT_KEY = isProduction
  ? 'live_ck_4vZnjEJeQVxXRxOmBLYVPmOoBN0k'
  : 'test_ck_mnRQoOaPz8LbQP6WpJeVy47BMw6v';

// Account API uses a dedicated staging host when APP_ENV is staging.
export const ACCOUNT_API_HOST = {
  production: 'api.account.realworld.to',
  staging: 'staging-plan-account.realworld.to',
  development: 'api-test.account.realworld.to'
}[APP_ENV];
